var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7675 10.27C21.5745 9.86652 21.4767 8.68509 20.6144 8.41978L4.8053 3.55543C4.03802 3.31935 3.31935 4.03802 3.55543 4.8053L8.41978 20.6144C8.68509 21.4767 9.86652 21.5745 10.27 20.7675L13.6201 14.0673C13.7169 13.8738 13.8738 13.7169 14.0673 13.6201L20.7675 10.27Z",
    stroke: "#004FC6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationIcon);
export default __webpack_public_path__ + "static/media/navigation-icon.67cdf2bc20d9c23523258dbe535241f7.svg";
export { ForwardRef as ReactComponent };